import React, { useEffect, useMemo, useState } from 'react';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import { Outlet, useOutletContext } from 'react-router-dom';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { useGetModelMatrix, useModelFilters } from './hooks';
import LoaderFull from '../shared/loader-full-screen';
import { Autocomplete, TextField } from '@mui/material';
import { PAGE_SIZE_OPTIONS, sortDropdownOptions } from '../utils';

function ModelMatrix() {
	const { getpageSizeCall, setpageSizeCall } = useOutletContext();
	const getfilterHook = useModelFilters();
	const [selectedVendor, setSelectedVendor] = useState('');
	const [selectedCategory, setSelectedCategory] = useState('');
	const [Filters, setFilters] = useState([]);
	const [listData, setlistData] = useState([]);
	const global_search_hook = useGetModelMatrix();
	const [page, setPage] = useState(1);
	const [pageSize, setPageSize] = useState(null);

	async function searchData(page=1) {
		let body = {};
		console.log(selectedCategory, 'category');
		if (selectedCategory) {
			body['category_id'] = selectedCategory?.category_id;
		}
		if (selectedVendor) {
			body['vendor_id'] = selectedVendor?.vendor_id;
		}
		body['page'] = page;
		body['limit'] = pageSize
		setlistData([]);
		global_search_hook.mutate(body);
	}

	useEffect(() => {
		if (global_search_hook?.data) {
			console.log(global_search_hook.data, 'hook data');
			setlistData(global_search_hook.data?.data || []);
		}
	}, [global_search_hook?.data, global_search_hook?.isSuccess]);

	useEffect(() => {
		if (getfilterHook?.data) {
			console.log(getfilterHook.data, 'filter data');
			setFilters(getfilterHook.data.data);
		}
	}, [getfilterHook?.data, getfilterHook?.isSuccess]);

	function checkdisabled() {
		if (global_search_hook.isPending) {
			return true;
		}

		return false;
	}

	useEffect(() => {
		if (pageSize){
			global_search_hook.mutate({"limit": pageSize, "page": page});
		}
	}, []);

	function getUniqueVendors(lst, selectedCategory = null) {
		const uniqueVendors = [];
		const seenVendorIds = new Set();

		lst
			?.filter((item) => {
				if (!selectedCategory) return true;
				return item.category_id === selectedCategory?.category_id;
			})
			?.forEach((item) => {
				if (!seenVendorIds.has(item.vendor_id)) {
					seenVendorIds.add(item.vendor_id);
					uniqueVendors.push({
						vendor_id: item.vendor_id,
						vendor_name: item.vendor_name,
					});
				}
			});

		return sortDropdownOptions(uniqueVendors, (o) => o.vendor_name);
	}

	function getUniqueCategories(lst, selectedVendor = null) {
		const uniqueCategories = [];
		const seenCategoryIds = new Set();

		lst
			?.filter((item) => {
				if (!selectedVendor) return true;
				return item.vendor_id === selectedVendor?.vendor_id;
			})
			?.forEach((item) => {
				if (!seenCategoryIds.has(item.category_id)) {
					seenCategoryIds.add(item.category_id);
					uniqueCategories.push({
						category_id: item.category_id,
						category_name: item.category_name,
					});
				}
			});

		return sortDropdownOptions(uniqueCategories, (o) => o.category_name);
	}

	const uniqueVendors = useMemo(
		() => getUniqueVendors(Filters, selectedCategory),
		[Filters, selectedCategory]
	);
	const uniqueCategories = useMemo(
		() => getUniqueCategories(Filters, selectedVendor),
		[Filters, selectedVendor]
	);

	useEffect(() => {
	  searchData(page);
	}, [page]);

	

	useEffect(() => {
		// Define an async function inside useEffect
		const fetchPageSize = async () => {
			try {
				const page_size = await getpageSizeCall();
				console.log(page_size, 'pg in client');
				setPageSize(page_size); // Set the page size state
			} catch (error) {
				console.error('Error fetching page size:', error);
			}
		};

		fetchPageSize(); // Call the async function
	}, []); //

	const handlePageSizeChange = async (event) => {
		const selectedPageSize = event.target.value;
		setPageSize(null);
		let ret = await setpageSizeCall(selectedPageSize);
		try {
			const page_size = await getpageSizeCall();
			console.log(page_size, 'pg in client');
			setPageSize(page_size); // Set the page size state
		} catch (error) {
			console.error('Error fetching page size:', error);
		}
	};
	useEffect(() => {
		if (pageSize) {

			if (page == 1) {
				searchData(1)
			} else {
				setPage(1)
			}
		}
	}, [pageSize]);



	return (
		<div className="min-h-screen bg-gray-50 w-full">
			{/* Header */}
			<div className="lg:flex gap-4 justify-between items-center vLBG py-4 px-6 w-full">
				<div className='flex-none flex items-center'>
					<h1 className="text-lg font-normal text-primary">
						Model <strong className="font-black">Metrics</strong>
					</h1>
				</div>
				<div className="grow flex gap-4 items-center justify-end">
					{/* Search Bar */}
						<div className="w-full sm:w-[48%] lg:w-[38.5%]">
							<Autocomplete
								id="category"
								options={uniqueCategories}
								getOptionLabel={(option) =>
									typeof option === 'string' ? option : option['category_name']
								}
								isOptionEqualToValue={(option, value) =>
									option.category_id === value.category_id
								}
								value={selectedCategory}
								onChange={(event, newValue) => {
									console.log(newValue, 'new value');

									setSelectedCategory(newValue);
								}}
								// onInputChange={(event, newInputValue, reason) => {
								// 	if (reason === 'input') {
								// 		setInputVal(newInputValue);
								// 	}
								// }}
								loading={getfilterHook.isFetching}
								loadingText="Loading..."
								// noOptions={getfilterHook.isFetching ? false : true}
								// noOptionsText={`No ${col['lable']} Match`}
								renderInput={(params) => (
									<TextField {...params} label="Categories" fullWidth />
								)}
								renderOption={(props, option) => (
									<li  {...props} key={option.category_id}>
										{option['category_name']}
									</li>
								)}
							/>

							{/* )}
							 */}
						</div>

						<div className="w-full sm:w-[48%] lg:w-[38.5%]">
							<Autocomplete
								id="vendor"
								options={uniqueVendors}
								getOptionLabel={(option) =>
									typeof option === 'string' ? option : option['vendor_name']
								}
								isOptionEqualToValue={(option, value) =>
									option.vendor_id === value.vendor_id
								}
								value={selectedVendor}
								onChange={(event, newValue) => {
									console.log(newValue, 'new value');

									setSelectedVendor(newValue);
								}}
								// onInputChange={(event, newInputValue, reason) => {
								// 	if (reason === 'input') {
								// 		setInputVal(newInputValue);
								// 	}
								// }}
								loading={getfilterHook.isFetching}
								loadingText="Loading..."
								// noOptions={getfilterHook.isFetching ? false : true}
								// noOptionsText={`No ${col['lable']} Match`}
								renderInput={(params) => (
									<TextField {...params} label="Vendors" fullWidth />
								)}
								renderOption={(props, option) => (
									<li  {...props} key={option.vendor_id}>
										{option['vendor_name']}
									</li>
								)}
							/>

							{/* )}
							 */}
						</div>

						<button
							type="button"
							disabled={checkdisabled()}
							onClick={() => {
								searchData();
							}}
							className="bg-blue-800 hover:bg-indigo-700 px-4 py-2 h-10 rounded-md text-white flex items-center font-black disabled:bg-slate-300 disabled:text-slate-700"
						>
							<span className="material-icons mr-1 text-sm">refresh</span>
							Search
						</button>
				</div>
			</div>

			{/* Collapsible Filters */}
			{/* {showFilters && (
        <div className='p-6'>
          <div className="flex flex-wrap gap-4">
            <AutoCompleteDropdown setFilters={setFilters} Filters={Filters} col={{ id: "fname", name: "fname", lable: "Invoice Name" }} />
            <AutoCompleteDropdown setFilters={setFilters} Filters={Filters} col={{ id: "client_id", name: "client", lable: "Client Name" }} />
            <AutoCompleteDropdown setFilters={setFilters} Filters={Filters} col={{ id: "vendor_id", name: "vendor", lable: "Vendor Name" }} />
            <AutoCompleteDropdown setFilters={setFilters} Filters={Filters} col={{ id: "category_id", name: "category_name", lable: "Category Name" }} />
            <AutoCompleteDropdown setFilters={setFilters} Filters={Filters} col={{ id: "project_type_id", name: "project_type", lable: "Project Type" }} />
            <div className='flex lg:w-[49%] items-center mb-2'>
                <CustomDatePicker setFilters={setFilters} Filters={Filters} col={{ name: "published_on", lable: "Published On" }} />
            </div>
          </div>
        </div>
      )} */}

			{/* Main Content */}
			<div className="w-full p-6 pb-0 border-t">
				<div className="listDHeight larger overflow-auto">
				{/* Sort Controls */}
				{/* <div className="flex flex-wrap gap-4 mb-6">
          <div className="flex items-center space-x-2 text-sm text-gray-600">
            <span>Sort by:</span>
            <button
              onClick={() => handleSort('publishedOn')}
              className={`flex items-center space-x-1 px-3 py-1 rounded-md transition-colors ${sortField === 'publishedOn' ? 'bg-blue-100 text-blue-800' : 'hover:bg-gray-100'
                }`}
            >
              <span>Published</span>
              {getSortIcon('publishedOn')}
            </button>
            <button
              onClick={() => handleSort('uploadedOn')}
              className={`flex items-center space-x-1 px-3 py-1 rounded-md transition-colors ${sortField === 'uploadedOn' ? 'bg-blue-100 text-blue-800' : 'hover:bg-gray-100'
                }`}
            >
              <span>Uploaded</span>
              {getSortIcon('uploadedOn')}
            </button>
            <button
              onClick={() => handleSort('updatedOn')}
              className={`flex items-center space-x-1 px-3 py-1 rounded-md transition-colors ${sortField === 'updatedOn' ? 'bg-blue-100 text-blue-800' : 'hover:bg-gray-100'
                }`}
            >
              <span>Updated</span>
              {getSortIcon('updatedOn')}
            </button>
          </div>
        </div> */}

				{/* Results Count */}
				{/* <div className="mb-6 text-sm text-gray-600">
          Showing {startIndex + 1}-{Math.min(startIndex + itemsPerPage, sortedData.length)} of {sortedData.length} results
        </div> */}

				{/* List View */}

				{global_search_hook.isPending ? (
					<LoaderFull />
				) : (
					<Outlet
						context={{
							paginatedData: listData,
							vendor_id: selectedVendor?.vendor_id ,
							category_id: selectedCategory?.category_id,
							searchData: searchData
						}}
					/>
				)}
				</div>
			</div>
			<div className="flex justify-center gap-3 pt-0">
				{!global_search_hook.isLoading && (
					<>
						<div className="flex items-center justify-between space-x-4">
							{/* Pagination Component */}
							<div className="flex items-center space-x-2">
								{/* <p>Rows per page</p> */}
								{pageSize ? (
									<FormControl
											variant="outlined"
											size="small"
											sx={{
												minWidth: 120,
												'& .MuiOutlinedInput-root': {
												borderRadius: '0.375rem', // rounded-md
												backgroundColor: 'white',
												fontSize: '0.875rem', // text-sm
												},
												'& .MuiOutlinedInput-notchedOutline': {
												borderColor: '#D1D5DB', // border-gray-300
												},
												'&:hover .MuiOutlinedInput-notchedOutline': {
												borderColor: '#60A5FA', // blue-400 on hover
												},
												'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
												borderColor: '#3B82F6', // focus:ring-blue-500
												borderWidth: '2px',
												},
											}}
											>
											<InputLabel id="page-size-label">Page Size</InputLabel>
											<Select
												labelId="page-size-label"
												value={pageSize || ''}
												onChange={handlePageSizeChange}
												label="Page Size"
											>
												{PAGE_SIZE_OPTIONS.map((size) => (
												<MenuItem key={size} value={size}>
													{size}
												</MenuItem>
												))}
											</Select>
											</FormControl>
								) : (
									<div className="w-[60px] h-[40px] flex justify-center items-center bg-gray-100 rounded-md text-sm text-center border border-gray-300">
										<span className="material-icons text-sm animate-spin">
											autorenew
										</span>{' '}
										{/* Spinner */}
									</div>
								)}
							</div>
						<Pagination
							page={page}
							onChange={(e, value) => {
								setPage(value);
								
							}}
							count={Math.ceil(
								global_search_hook.data?.count /
								pageSize
							)}
							color="primary"
							variant="outlined"
							shape="rounded"
						/>
					</div>
					</>
				)}
			</div>
		</div>
	);
}

export default ModelMatrix;
